import React, { useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { logger } from "@/lib/logger";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  const process = useCallback(async () => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    try {
      await api.post("/auth/session", { session_id: sessionId });
      const me = await api.get("/auth/me");
      setUser(me.data);
      window.history.replaceState(null, "", "/dashboard");
      navigate("/dashboard", { replace: true, state: { user: me.data } });
    } catch (e) {
      logger.error("auth callback failed", e);
      navigate("/", { replace: true });
    }
  }, [location.hash, navigate, setUser]);

  useEffect(() => { process(); }, [process]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#FAFAF9]">
      <div className="flex items-center gap-3 text-[#5F7368]">
        <Loader2 className="w-5 h-5 animate-spin" />
        <span>Iniciando tu sesión…</span>
      </div>
    </div>
  );
}
